//言語切替処理
function sendUrllocation(locations){
    var url = location.href;
    switch (locations) {
      case 'jp':
        var result = url.replace('https://avlde.com/en', 'https://avlde.com');
        window.location.href = result;
        break;
      case 'en':
        var result = url.replace('https://avlde.com', 'https://avlde.com/en');
        window.location.href = result;
        break;
    }
}